import { createFileRoute, redirect } from '@tanstack/react-router';
import { lookupDomain } from '@/auth/realm';
import { lastTenant } from '@/auth/session';

/**
 * Racine : sur le domaine personnalisé d'un locataire (F9.11), son organisation ; sinon la dernière
 * organisation utilisée si la session est encore là, sinon /login. Les routes applicatives vivent
 * toutes sous /$tenant/… (le tenant est toujours dans l'URL ; l'en-tête X-Tenant est posé par le
 * mutator, jamais à la main).
 */
export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    const domain = await lookupDomain(window.location.hostname);
    if (domain) throw redirect({ to: '/$tenant/overview', params: { tenant: domain.tenantId } });
    const last = lastTenant();
    if (last) throw redirect({ to: '/$tenant/overview', params: { tenant: last.tenantId } });
    throw redirect({ to: '/login' });
  },
});
